
"use strict";

/*
{
  select: [<column spec>]
  from: <source spec>
  groupBy: [<group>]
  where: <where filter>
  having: <having filter>
  order: 
  limit:
  intervals: ['od/do']
  granularity: "..."
  timeZone:
  timeZoneOffset:
}
*/

var GroupByType = exports.GroupByType = {
 id: 'group',
  name: 'Group by',
  // noSubField: true,
  // noFilters: true,
  template: {
    field: '',
    regex: ''
  }
};


var ColumnTypes = exports.ColumnTypes = {};
var ColumnTypesList = exports.ColumnTypesList = [
  {
    id: 'column',
    name: 'Column',
    noRootField: true,
    noFilters: true,
    template: {
      type: 'column',
      parent: null,
      ref: null
    }
  },
  {
    id: 'constant',
    name: 'Constant',
    noRootField: true,
    noFilters: true,
    template: {
      type: 'constant',
      parent: null,
      value: 0
    }
  },
  {
    id: 'count',
    name: 'Count',
    template: {
      type: 'count',
      parent: null,
      filter: null
    }
  },
  {
    id: 'max',
    name: 'Max',
    template: {
      type: 'max',
      parent: null,
      field: '',
      filter: null
    }
  },
  {
    id: 'min',
    name: 'Min',
    template: {
      type: 'min',
      parent: null,
      field: '',
      filter: null
    }
  },
  {
    id: 'sum',
    name: 'Sum',
    template: {
      type: 'sum',
      parent: null,
      field: '',
      filter: null
    }
  },
  {
    id: 'unique',
    name: 'Unique',
    template: {
      type: 'unique',
      parent: null,
      field: '',
      filter: null
    }
  },
  {
    id: '+',
    name: 'Arithmetic: +',
    noFilters: true,
    template: {
      type: '+',
      parent: null,
      args: []
    }
  },
  {
    id: '-',
    name: 'Arithmetic: -',
    noFilters: true,
    template: {
      type: '-',
      parent: null,
      args: []
    }
  },
  {
    id: '*',
    name: 'Arithmetic: *',
    noFilters: true,
    template: {
      type: '*',
      parent: null,
      args: []
    }
  },
  {
    id: '/',
    name: 'Arithmetic: /',
    noFilters: true,
    template: {
      type: '/',
      parent: null,
      args: []
    }
  },
  {
    id: 'quotient',
    name: 'Quotient',
    noFilters: true,
    template: {
      type: 'quotient',
      parent: null,
      args: []
    }
  }
];
var each = require('../../lib/deep-query-api/lib/collections').each;

each(ColumnTypesList, function(spec) { ColumnTypes[spec.id] = spec; });
